import React from 'react';
import PropTypes from 'prop-types';
import { AIconButton } from '../atoms';

export default function MTableProductRow({
	id,
	title,
	category,
	type,
	onEdit,
	onDelete,
}) {
	const handleEdit = () => {
		onEdit(id);
	};
	const handleDelete = () => {
		onDelete(id);
	};

	return (
		<article className="m-table-row">
			<div className="row-body m-table-column--3">
				<p>{title}</p>
				<p>{category}</p>
				<p>{type}</p>
			</div>
			<div className="row-controls">
				<AIconButton type="edit" className="no-color" onClick={handleEdit} />
				<AIconButton type="delete" className="no-color" onClick={handleDelete} />
			</div>
		</article>
	);
}

MTableProductRow.propTypes = {
	id: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	category: PropTypes.string.isRequired,
	type: PropTypes.string.isRequired,
	onEdit: PropTypes.func.isRequired,
	onDelete: PropTypes.func.isRequired,
};




// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.table-product-row.js